import { useCallback, useContext } from 'react'
import { useMutation } from '@tanstack/react-query'
import { createBatteryDefFetch } from 'store/middlewares/assessment.crud'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { CreateBatteryContext } from './CreateBatteryContext'

const useCreateBatteryBtn = () => {
    const { name, label, intendedFor, selectedAssessmentDefs } = useContext(CreateBatteryContext)
    const navigate = useNavigate()

    const { mutate: createBattery, isPending } = useMutation({
        mutationFn: createBatteryDefFetch,
        onSuccess: () => {
            toast.success('הסוללה נוצרה בהצלחה', toastConfig)
            navigate(app.assessmentLibrary)
        },
        onError: (error) => {
            const { data } = error?.response || {}
            const msg = data?.detail || data?.error || 'אופס, משהו השתבש ביצירת הסוללה'
            toast.error(msg, toastConfig)
        }
    })

    const action = useCallback(() => {
        console.log("action create");
        createBattery({
            name,
            label,
            intended_for: intendedFor?.id,
            assessment_defs: selectedAssessmentDefs.map((a, index) => ({ id: a.id, index })),
        })
    }, [name, label, intendedFor, selectedAssessmentDefs, createBattery])

    return { action, isPending }
}

export default useCreateBatteryBtn
